import { IActivityLogResponseById } from "@/utils/types/activityLogs";
import { formatActivityDate } from "@/utils/constant/dateUtils";

interface ActivityLogModalProps {
  activityLog: IActivityLogResponseById;
}

const ActivityLogModal = ({ activityLog }: ActivityLogModalProps) => {
  if (!activityLog) {
    return null;
  }

  const detailItem = (label: string, value: any) => (
    <div className="flex flex-col gap-1 py-2">
      <span className="text-sm text-gray-500">{label}</span>

      <div className="flex items-center gap-2">
        <span className="break-all font-medium text-gray-800">
          {value ?? "—"}
        </span>
      </div>
    </div>
  );

  return (
    <div className="animate-fadeIn space-y-5">
      {/* Two-column grid */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {detailItem("Activity Log", activityLog.activity_title)}
        {detailItem("Activity Type", activityLog.activity_type)}

        {detailItem(
          "Timestamp",
          formatActivityDate(activityLog.created_on ?? "")
        )}

        {detailItem("Is Active", activityLog.is_active ? "Yes" : "No")}
      </div>

      {/* Description */}
      {activityLog.activity_description && (
        <div className="border-t pt-3">
          <span className="text-sm text-gray-500">Description</span>
          <p className="mt-2 leading-relaxed text-gray-800">
            {activityLog.activity_description}
          </p>
        </div>
      )}
    </div>
  );
};

export default ActivityLogModal;
